var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn database-of-devices-btn btn-default",attrs:{"href":"https://cacertappliances.energy.ca.gov/Pages/ApplianceSearch.aspx","target":"_blank"}},[_vm._v("Database List.")])
}
var staticRenderFns = []

export { render, staticRenderFns }